/** Same-origin API prefix. Never include a host; CRA/nginx proxy /api to the backend. */
export const getApiBaseUrl = () => "/api/v1";

/** Public site origin from env. Never hardcode a host. */
export function getPublicSiteUrl() {
  const fromEnv = String(process.env.REACT_APP_SITE_URL || "")
    .trim()
    .replace(/\/+$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

export function toAbsoluteUrl(path) {
  const raw = String(path || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const origin = getPublicSiteUrl();
  if (!origin) return raw.startsWith("/") ? raw : `/${raw}`;
  return `${origin}${raw.startsWith("/") ? raw : `/${raw}`}`;
}

function configuredSiteOrigin() {
  const origin = String(process.env.REACT_APP_SITE_URL || "")
    .trim()
    .replace(/\/+$/, "");
  if (!origin || /localhost|127\.0\.0\.1/i.test(origin)) return "";
  return origin;
}

function normalizeSitePath(path) {
  const withoutQuery = String(path || "").trim().split(/[?#]/)[0];
  if (!withoutQuery) return "";
  const withSlash = `/${withoutQuery.replace(/^\/+/, "")}`.replace(/\/{2,}/g, "/");
  if (withSlash === "/") return "/";
  return withSlash.replace(/\/+$/, "");
}

/** Absolute URL from REACT_APP_SITE_URL only. Never uses window.location (avoids localhost). */
export function toConfiguredAbsoluteUrl(path) {
  const raw = String(path || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw.split(/[?#]/)[0]);
      if (/localhost|127\.0\.0\.1/i.test(url.hostname)) return normalizeSitePath(url.pathname);
      return `${url.origin}${normalizeSitePath(url.pathname) || "/"}`;
    } catch {
      return "";
    }
  }
  const normalizedPath = normalizeSitePath(raw);
  if (!normalizedPath) return "";
  const origin = configuredSiteOrigin();
  if (!origin) return normalizedPath;
  return normalizedPath === "/" ? `${origin}/` : `${origin}${normalizedPath}`;
}

/** Same-origin media path, e.g. /media/homepage/hero.jpg */
export const mediaUrl = (key) => {
  const cleaned = String(key || "").replace(/^\/+/, "");
  return `/media/${cleaned}`;
};

/** Accept stored /media/... paths or raw keys. Never pass through a remote host. */
export function publicMediaSrc(value) {
  const raw = String(value || "").trim();
  if (!raw || /^https?:\/\//i.test(raw)) return "";
  if (raw.startsWith("/media/")) return raw;
  return mediaUrl(raw.replace(/^media\//, ""));
}

export const HOME_MEDIA = {
  logo: "homepage/at-logo.webp",
  hero: "homepage/hero.jpg",
  quality: "homepage/quality.png",
  supply: "homepage/reliable-supply.png",
  trusted: "homepage/trusted.png",
  about: "homepage/about-gloves.png",
  login: "homepage/login-bg.jpg",
};
